import type {Control} from "react-hook-form";
import type {zodCreateTicketType} from "@/modules/tickets";
import {Box, Paper, Typography} from "@mui/material";
import {FieldPair} from "@/modules/tickets/components/FieldPair";

interface Props {
    control: Control<zodCreateTicketType>;
}

type AdditionalInfoKeys =
    | 'iin'
    | 'school_bin'
    | 'school_title'
    | 'first_name'
    | 'last_name'
    | 'patronymic'
    | 'category'
    | 'group_title'
    | 'start_date'
    | 'end_date'
    | 'maintenance_grade'
    | 'rules_grade'
    | 'practice_grade';

const fields: { key: AdditionalInfoKeys, label: string }[] = [
    {key: 'iin', label: 'ИИН'},
    {key: 'school_bin', label: 'БИН школы'},
    {key: 'school_title', label: 'Название школы'},
    {key: 'first_name', label: 'Имя'},
    {key: 'last_name', label: 'Фамилия'},
    {key: 'patronymic', label: 'Отчество'},
    {key: 'category', label: 'Категория'},
    {key: 'group_title', label: 'Группа'},
    {key: 'start_date', label: 'Дата начала'},
    {key: 'end_date', label: 'Дата окончания'},
    {key: 'maintenance_grade', label: 'Оценка по техническому обслуживанию'},
    {key: 'rules_grade', label: 'Оценка по правилам'},
    {key: 'practice_grade', label: 'Оценка за практику'}
];

export function ChangeOldInfo({control}: Props) {

    return (
        <Paper
            elevation={0}
            sx={{
                p: 3,
                borderRadius: '12px',
                border: '1px solid #E0E0E0',
                background: '#FAFAFA',
                mb: 3
            }}
        >
            <Typography
                variant="h6"
                fontWeight={600}
                mb={2}
            >
                Корректировка данных
            </Typography>
            <Typography
                variant="body2"
                color="#666"
                mb={2}
            >
                Для каждого поля введите некорректное текущее значение слева и новое правильное значение справа.
            </Typography>
            <Typography
                variant="body2"
                color="#666"
                mb={3}
            >
                * Заполняйте только те поля, которые требуют исправления, указывая текущее некорректное и желаемое новое
                значение
            </Typography>

            <Box>
                {
                    fields.map(({label, key}) => (
                        <FieldPair
                            key={key}
                            control={control}
                            label={label}
                            fieldname={key}
                        />
                    ))
                }
            </Box>
        </Paper>
    );
}